import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'

function SearchButton(args) {
  const [isSearching, setSearching] = useState(false)

  useEffect(() => {
    if (isSearching) {
      args.action() // Do search...
      setSearching(false)
    }
  }, [isSearching]);

  const handleClick = () => setSearching(true)

  return (
    <Button
      variant="primary"
      disabled={isSearching}
      onClick={!isSearching ? handleClick : null}
    >
      {isSearching ? 'Searching…' : 'Search'}
    </Button>
  );
}

export default SearchButton
